module.exports = __webpack_public_path__ + "static/media/book.3978ccbe.gif";